import { render, staticRenderFns } from "./privacyMechanic.vue?vue&type=template&id=7f9f9f90&scoped=true"
import script from "./privacyMechanic.vue?vue&type=script&lang=js"
export * from "./privacyMechanic.vue?vue&type=script&lang=js"
import style0 from "./privacyMechanic.vue?vue&type=style&index=0&id=7f9f9f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9f9f90",
  null
  
)

export default component.exports